<div class="aligned" [ngClass]="{
    'aligned-none':
      currentStep === 'contact' ||
      currentStep === 'success' ||
      currentStep === 'failure'
  }" [ngStyle]="currentStep === 'preorder' || currentStep === 'contact' ||
  currentStep === 'success' ||
  currentStep === 'failure' ? {'display': 'none'} : {}">
  <div class="stepper">
    <div class="container">
      <ul class="progressbar">
        <li [ngClass]="{
            active:
              lastCompletedStep === 'SUMMARY' ||
              lastCompletedStep === 'SHORT' ||
              lastCompletedStep === 'SOCKS',
            current: currentStep === 'jersey'
          }" (click)="goStepMaillot($event)">
          {{ "Jersey" | translate }}
        </li>
        <li [ngClass]="{
            active:
              lastCompletedStep === 'SUMMARY' || lastCompletedStep === 'SOCKS',
            current: currentStep === 'short'
          }" (click)="goStepShort($event)">
          {{ "Short" | translate }}
        </li>
        <li [ngClass]="{
            active: lastCompletedStep === 'SUMMARY',
            current: currentStep === 'sock'
          }" (click)="goStepSocks($event)">
          {{ "Socks" | translate }}
        </li>
        <li [ngClass]="{ active: lastCompletedStep === 'SUMMARY' }" (click)="goStepSummary($event)">
          {{ "Kit" | translate }}
        </li>
      </ul>
    </div>
  </div>
</div>